var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('x-popup', {
        class: [
            'second-retain-container',
            _vm.$style.bg
        ],
        style: {
            width: '75%'
        },
        attrs: {
            "value": _vm.value,
            "title": "",
            "safeAreaInsetBottom": true,
            "close-on-click-overlay": false,
            "position": "center",
            "closeable": "",
            "close-icon-position": "top-right",
            "teleport": "body",
            "round": ""
        },
        on: {
            "click-close-icon": _setup.clickCloseBtn
        }
    }, [
        _c('div', {
            class: _vm.$style.content
        }, [
            _c('div', {
                class: _vm.$style.smallCircle
            }),
            _c('p', {
                class: _vm.$style.title
            }, [
                _vm._v("¿Seguro que quiere perder estos beneficios?")
            ]),
            _c('ul', {
                class: _vm.$style.imgBox
            }, [
                _c('li', [
                    _c('img', {
                        attrs: {
                            "src": require("@/assets/img/retain/small-img1.png"),
                            "alt": ""
                        }
                    }),
                    _c('span', [
                        _vm._v("Proceso sencillo")
                    ])
                ]),
                _c('li', [
                    _c('img', {
                        attrs: {
                            "src": require("@/assets/img/retain/small-img2.png"),
                            "alt": ""
                        }
                    }),
                    _c('span', [
                        _vm._v("Aprobación rápida")
                    ])
                ]),
                _c('li', [
                    _c('img', {
                        attrs: {
                            "src": require("@/assets/img/retain/small-img3.png"),
                            "alt": ""
                        }
                    }),
                    _c('span', [
                        _vm._v("Protegiendo la privacidad")
                    ])
                ])
            ]),
            _c('van-button', {
                class: _vm.$style.yesBtn,
                style: {
                    color: '#fff'
                },
                attrs: {
                    "native-type": "button",
                    "block": ""
                },
                on: {
                    "click": _setup.clickContinueBtn
                }
            }, [
                _vm._v(" Seguir ")
            ]),
            _c('van-button', {
                class: _vm.$style.noBtn,
                style: {
                    color: '#003333'
                },
                attrs: {
                    "native-type": "button"
                },
                on: {
                    "click": function($event) {
                        return _setup.emit('go-home');
                    }
                }
            }, [
                _vm._v(" Salir ")
            ])
        ], 1)
    ]);
};
var staticRenderFns = [];
export { render, staticRenderFns };
